// 1. ADD user to the existing user list
export const addUserToList = (users, userToAdd) => {
  return [...users, { ...userToAdd }];
};
